import React from 'react'

import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material'

export default function SelectField({ id, label, options, handleChange, value, required = true, isValid = true }) {

    const defaultValue = (options, value) => {
        const selectedOption = options.find(option => option.value === value)
        return selectedOption ? selectedOption.value : ""
    }
    
    const onChange = (event) => {
        handleChange({ value: event.target.value })
    }

    // LOGIC ADDED:
    // Check if the field actually has a value selected
    const hasValue = value !== "" && value !== null && value !== undefined;
    
    // Only show the error if the parent says it's invalid AND the field is empty.
    // As soon as the user selects something, 'hasValue' becomes true and the error hides.
    const showError = !isValid && !hasValue;

    return (
        // Added error={showError} here so the Label turns red too
        <FormControl fullWidth error={showError} sx={{ marginBottom: 2}}>
            <InputLabel id={`${label}-label`}>{label}</InputLabel>
            <Select 
                fullWidth
                id={id}
                label={label}
                value={defaultValue(options, value) || ""}
                onChange={onChange}
                name={id}
                required={required}
                // Updated to use the calculated logic
                error={showError}
            >
                {
                    options.map(option => {
                        return (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)
                    })
                }
            </Select>
            {/* Only show text if our logic says so */}
            { showError && <FormHelperText>Please enter a valid value</FormHelperText>}
        </FormControl>
    )
}
